import { createActionGroup, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import {
  MaterialRequestListContent,
  MaterialRequestListSearchCriteria
} from '../../model/material-request-list.model';

export const MaterialRequestListAction = createActionGroup({
  source: 'Material Request List',
  events: {
    RequestList: props<{ criteriaObj: MaterialRequestListSearchCriteria }>(),
    ResponseList: props<{
      data: Pagination<MaterialRequestListContent>;
    }>()
  }
});
